/**
 * @generated SignedSource<<1e4f8d1b42a1da4fe524e533968911c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Verb = "ACCOUNT_CHANGED" | "ADDED_DUE_DATE" | "ASSIGNED_ACTION_ITEM" | "ASSIGNED_TALKING_POINT" | "BILLING_ADDON_APPLIED" | "BILLING_ADDON_REMOVED" | "BILLING_PLAN_CANCELLED" | "BILLING_PLAN_CHANGED" | "BILLING_PLAN_UNCANCELLED" | "CHANNEL_NEW_MEMBER" | "CHANNEL_NEW_POST" | "COMMENT_MENTION" | "COMMENT_NEW" | "COMMENT_REPLY" | "COMMENT_RESOLVE" | "COMPLETED_ACTION_ITEM" | "DEVELOPER_API_KEY_CREATED" | "DEVELOPER_API_KEY_DELETED" | "DEVELOPER_API_KEY_DISABLED" | "DEVELOPER_API_KEY_ENABLED" | "EDITED_DUE_DATE" | "EDITED_NOTE" | "EDITED_STREAM_DESCRIPTION" | "GAVE_FEEDBACK" | "GAVE_MEETING_FEEDBACK" | "GAVE_PRAISE" | "KEY_RESULT_ASSIGNED" | "KEY_RESULT_ASSIGNED_TEAM" | "KEY_RESULT_CREATED_FLOATING_DESCRIPTION" | "KEY_RESULT_CURRENT_VALUE_CHANGE" | "KEY_RESULT_DELETED" | "KEY_RESULT_DUE_DATE_CHANGE" | "KEY_RESULT_START_VALUE_CHANGE" | "KEY_RESULT_TARGET_VALUE_CHANGE" | "KEY_RESULT_UPDATED" | "MEETING_BRIEF_READY" | "MEETING_COPILOT_PAYG_AMOUNT_CHANGED" | "MENTIONED_USER" | "MERGED_STREAMS" | "OBJECTIVE_ARCHIVED" | "OBJECTIVE_ASSIGNED" | "OBJECTIVE_ASSIGNED_TEAM" | "OBJECTIVE_CREATED" | "OBJECTIVE_CREATED_FLOATING_DESCRIPTION" | "OBJECTIVE_DELETED" | "OBJECTIVE_DUE_DATE_CHANGE" | "OBJECTIVE_PROGRESS" | "OBJECTIVE_STATUS_CHANGE" | "OBJECTIVE_UPDATED" | "PAYMENT_INFORMATION_UPDATED" | "RECORDING_ADDED" | "RECORDING_FIRST_VIEWED" | "REMINDED_FEEDBACK_RESPONSE" | "REQUESTED_FEEDBACK" | "REQUESTED_NOTE_ACCESS" | "RESPONDED_TO_FEEDBACK_REQUEST" | "SHARED_FEEDBACK" | "SHARED_STREAM" | "STAY_INCENTIVE_DISCOUNT_APPLIED" | "STAY_INCENTIVE_REFUND_APPLIED" | "TRIAL_EXTENDED" | "TRIAL_RESTARTED" | "UNSHARED_STREAM" | "USER_ACTIVATED" | "USER_APP_ACTIVATED" | "USER_APP_DEACTIVATED" | "USER_CREATED" | "USER_DEACTIVATED" | "USER_DELEGATION_CREATED" | "USER_DELEGATION_REMOVED" | "USER_DELETED" | "USER_DISABLED" | "USER_EXPORT_REQUESTED" | "USER_INVITED_GUEST" | "USER_JOINED_FROM_INVITE" | "USER_JOINED_FROM_INVITE_LINK" | "USER_JOINED_FROM_SELF_SIGNUP" | "USER_LEFT_SHARED_STREAM" | "USER_LOGIN" | "USER_LOGIN_DELEGATED" | "USER_LOGOUT" | "USER_LOGOUT_DELEGATED" | "USER_UPDATED" | "WORKSPACE_APP_ACTIVATED" | "WORKSPACE_APP_DEACTIVATED";
export type AddNewUpdateMutation$variables = {
  connections: ReadonlyArray<string>;
  json: any;
  objectiveOrKrId: string;
  text: string;
};
export type AddNewUpdateMutation$data = {
  readonly Objective_CreateFloatingDescription: {
    readonly update: {
      readonly __typename: string;
      readonly actor: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      } | null;
      readonly cache: any;
      readonly createdAt: string;
      readonly data: any;
      readonly id: string;
      readonly verb: Verb;
    };
  } | null;
};
export type AddNewUpdateMutation = {
  response: AddNewUpdateMutation$data;
  variables: AddNewUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "json"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectiveOrKrId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v4 = [
  {
    "kind": "Variable",
    "name": "json",
    "variableName": "json"
  },
  {
    "kind": "Variable",
    "name": "objectiveOrKrId",
    "variableName": "objectiveOrKrId"
  },
  {
    "kind": "Variable",
    "name": "text",
    "variableName": "text"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "update",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "verb",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cache",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "data",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddNewUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateFloatingDescriptionMutation",
        "kind": "LinkedField",
        "name": "Objective_CreateFloatingDescription",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddNewUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreateFloatingDescriptionMutation",
        "kind": "LinkedField",
        "name": "Objective_CreateFloatingDescription",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "update",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ActivityEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f97a9549801e9b1da8a3a50d78154ec7",
    "id": null,
    "metadata": {},
    "name": "AddNewUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AddNewUpdateMutation(\n  $objectiveOrKrId: ID!\n  $text: String!\n  $json: JSON!\n) {\n  Objective_CreateFloatingDescription(objectiveOrKrId: $objectiveOrKrId, text: $text, json: $json) {\n    update {\n      id\n      __typename\n      actor {\n        id\n        fullName\n        image\n        email\n      }\n      verb\n      createdAt\n      cache\n      data\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac34f59966ff8f1f392e8e6585b22f27";

export default node;
